import React from 'react';
import { Input, Select, Icon, DatePicker, Col, Row } from 'antd';
import { VER_SERIES_LOG } from '../../../common/types/configuracionType';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';

const { Option, OptGroup } = Select;

class Filters extends React.Component {
    render() {
        var flagSerie = this.props.configuraciones.filter((m) => m.abreviatura === VER_SERIES_LOG).length >= 1 ? false : true;

        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            disabled={flagSerie}
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idAlmacenOrigen ?
                                    { key: this.props.filter.idAlmacenOrigen } : undefined
                            }
                            placeholder={"Seleccione Almacén Origen"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idAlmacenOrigen', option.key)}

                        >
                            {this.props.almacenes.map(item => (
                                <Option key={item.id} value={item.id}>{item.establecimiento} - {item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idAlmacenDestino ?
                                    { key: this.props.filter.idAlmacenDestino } : undefined
                            }
                            placeholder={"Seleccione Almacén Destino"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idAlmacenDestino', option.key)}

                        >
                            {this.props.almacenes.map(item => (
                                <Option key={item.id} value={item.id}>{item.establecimiento} - {item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch
                            labelInValue
                            value={
                                this.props.filter.idEstado ?
                                    { key: this.props.filter.idEstado } : undefined
                            }
                            placeholder={"Seleccione Estado"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange('idEstado', option.key)}

                        >
                            {this.props.estados.map(item => (
                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters; 